import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

/**
 * Ensures that a hash fragment in the URL is respected after initial sync has completed
 * and the page content has rendered
 */
export const useFollowUrlHash = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();

  const hasCompletedInitialSync = useTinybaseStore((state) => state.hasCompletedInitialSync);

  useEffect(() => {
    if (hasCompletedInitialSync && hash) {
      void navigate(hash, { replace: true, preventScrollReset: true });
    }
  }, [hasCompletedInitialSync]);
};
